import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';
import type { MapStyleKey } from '~/components/map/styles/map_styles';

interface MapState {
  style: MapStyleKey;
  center: [number, number];
}

const initialState: MapState = {
  style: 'standard',
  center: [53.468767, 20.683903],
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setMapStyle(state, action: PayloadAction<MapStyleKey>) {
      state.style = action.payload;
    },
    setMapCenter(state, action: PayloadAction<[number, number]>) {
      state.center = action.payload;
    },
  },
});

export const selectMapStyle = (state: RootState) => state.map.style;
export const selectMapCenter = (state: RootState) => state.map.center;

export const { setMapStyle, setMapCenter } = mapSlice.actions;
export default mapSlice.reducer;
